/**
* Updates the quantity value of the cart badge in the header.
*
* As there are multiple different headers in use with different ways of
* calling the provided function we need to find out which one to use.
*/
// Add qty parameter to allow passing 0 as cart quantity in confirmation page.
// When the customer reaches the confirmation page the current order still contains articles, hence the cart counter is NOT 0 at that moment.
export default function updateHeaderBadge(qty) {
    // Update function for IRW
    if (typeof window.updateNoOfCartItems === 'function' && document.forms.myAccount && document.forms.myAccount.storeId) {
        window.updateNoOfCartItems(document.forms.myAccount.storeId.value);
        return true;
    }

    // Update function for M2 - no helper function so need to generate DOM manually
    const m2BagIcon = document.querySelector('.js-shopping-cart-icon');
    if (m2BagIcon) {
        const updateQuantity = quantity => {
            const countryCode = window.Checkout.settings.country_code.toUpperCase();
            const domain = window.location.host.includes('ikeadt.com') ? '.ikeadt.com' : '.ikea.com';
            document.cookie = `IRMW_CART_COUNT_${countryCode}=${quantity};domain=${domain};path=/`;
            const event = document.createEvent('Event');
            event.initEvent('addtocart', true, true);
            document.body.dispatchEvent(event);
        };

        // If the quantity is passed as param, then update directly. No need to call any API.
        if (qty !== undefined) {
            updateQuantity(qty);
            return true;
        }

        // If checkout is enabled, use CS
        if (window.Checkout.settings.checkout.enable) {
            return window.Checkout.cartApi
                .run('getShoppingBag')
                .then(result => {
                    const quantity = result.items.reduce((acc, item) => acc + item.quantity, 0);
                    updateQuantity(quantity);
                    return true;
                })
                .catch(err => console.error(err)); // eslint-disable-line no-console
        }

        // If not, use IOWS
        const init = {
            method: 'GET',
            headers: new Headers({
                'Accept': 'application/vnd.ikea.iows+json;version=2.0',
                'Contract': window.Checkout.settings.shoppinglist.contract,
                'Consumer': window.Checkout.settings.shoppinglist.consumer,
            }),
            mode: 'cors',
            credentials: 'include',
        };
        const jsonIfOK = response => {
            if (response.ok) return response.json();
            throw new Error(response.status);
        };
        let endpoint;
        return window.Checkout.auth.getSessionContext()
            .then(userId => {
                endpoint = window.Checkout.settings.shoppinglist.endpoint + '/retail/iows/' + window.Checkout.settings.locale_url + '/customer/irw/' + userId + '/shoppingbags/onlineshoppingcart';
                const request = new Request(endpoint, init);
                return fetch(request);
            })
            .then(jsonIfOK)
            .then(response => {
                const listId = response.ShoppingBagRefList.ShoppingBagRef.BagId.$;
                const request = new Request(endpoint + '/' + listId, init);
                return fetch(request);
            })
            .then(jsonIfOK)
            .then(response => {
                const items = response.ShoppingBag.ShoppingBagSectionList.ShoppingBagSection.ShoppingBagItemList.ShoppingBagItem;
                let quantity;
                if (Array.isArray(items)) {
                    quantity = items.reduce((acc, item) => acc + item.ItemQty.$, 0);
                } else {
                    quantity = items.ItemQty.$;
                }
                updateQuantity(quantity);
                return true;
            })
            .catch(err => console.error(err)); // eslint-disable-line no-console
    }

    console.error('Couldn’t update header badge'); // eslint-disable-line no-console
    return false;
}
